// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1tWXZ","subheader":"ReorderModal_subheader__26Xx5","listWrap":"ReorderModal_listWrap__2jRmU"};